import {startStoreRecovery} from './utils/storeClient';
import SocialAlert from './components/SocialAlert';
const {readSeen,writeSeen,reconcileSocialAlert,resolveSocialAlert}=require('./utils/socialAlerts');
import DuelNotices from './components/DuelNotices';
import {notifyCosmetics} from './utils/useCosmetics';
import MarketScreen from './components/MarketScreen';
import SectionDock from './components/SectionDock';
import DailyLeaderboard from './components/DailyLeaderboard';
import {prepareOfflineDictionary,prepareOfflineProfile} from './offline/prepare';
import {seedIdentity,loadIdentity} from './utils/identityCache';
import {offlineShellReady} from './offline/shellReady';
import {flushSuggestions} from './offline/suggestions';
import OfflineGame from './offline/OfflineGame';
// 📁 components/App.jsx
import { useEffect, useLayoutEffect, useRef, useState } from 'react';

// Context

// Screens
import LoginScreen from './components/LoginScreen';
import RegisterScreen from './components/RegisterScreen';
import ConnectionStatus from './components/ConnectionStatus';
const {isConnectionNotice}=require('./utils/connectionNotice');
import StartScreen from './components/StartScreen';
import SocialScreen from './components/SocialScreen';
import MyGamesScreen from './components/MyGamesScreen';
import NewMatchScreen from './components/NewMatchScreen';
import GameScreen from './components/GameScreen';
import GameOverScreen from './components/GameOverScreen';
import DailyChallengeScreen from './components/DailyChallengeScreen';
import AchievementsScreen from './components/AchievementsScreen';
const { unlockedBetween } = require('./utils/achievements');

// Popups
import InvitePopup from './components/InvitePopup';
import { playSoundEffect, unlockSoundFromGesture } from './utils/soundEffects';
import { accountHeaders } from './utils/accountFetch';
import { recordConnectionEvent } from './utils/connectionTrace';

// Hooks / Utils
import useBackLayer from './hooks/useBackLayer';
import { useTimer } from './hooks/useTimer';
const { mergeChatSnapshot, applyRemovedMessage } = require('./utils/chatHistory');
const { connectionRecoveryReason, reconnectDelay } = require('./utils/connectionRecovery');
const { createResumeRecovery } = require('./utils/resumeRecovery');
const { getWebSocketUrl, getApiUrl } = require('./config/serverEndpoint');
const { resolveResultScreen } = require('./utils/screenRecovery');
const { connectWebPush, disconnectWebPush } = require('./utils/webPush');
const { connectNativeLinks } = require('./utils/nativeLinks');
const { connectNativePush, disconnectNativePush } = require('./utils/nativePush');

const { hydratePersistentSession, persistSession, forgetSession } = require('./utils/persistentSession');
const { installBackNavigation, backTarget, goBack } = require('./utils/backNavigation');
const { prepareRecoveryReturn, consumeRecoveryReturn } = require('./utils/recoveryReturn');
hydratePersistentSession(sessionStorage, localStorage);
prepareRecoveryReturn(window.location, window.history, sessionStorage, localStorage, forgetSession);

function OnlineApp({onOffline,offlineReady,initialOnlineOptions}) {
const [quickMatch, setQuickMatch] = useState(false);
const handoffGameRef=useRef(initialOnlineOptions?.gameId||null);
const [handoffMode,setHandoffMode]=useState(initialOnlineOptions?.mode);
const [handoffHomeAction,setHandoffHomeAction]=useState(initialOnlineOptions?.homeAction);
useEffect(() => {
  const handleGlobalError = (event) => {
    console.error('Global error:', event.error);
  };
  const handleUnhandledRejection = (event) => {
    console.error('Unhandled promise rejection:', event.reason);
  };

  window.addEventListener('error', handleGlobalError);
  window.addEventListener('unhandledrejection', handleUnhandledRejection);

  return () => {
    window.removeEventListener('error', handleGlobalError);
    window.removeEventListener('unhandledrejection', handleUnhandledRejection);
  };
}, []);

//Kullanıcı Bilgileri ve Giriş
const [username, setUsername] = useState(() => {
  return sessionStorage.getItem('username') || '';
});
const [authenticatedSessionGeneration, setAuthenticatedSessionGeneration] = useState(0);
useEffect(()=>startStoreRecovery(username),[username,authenticatedSessionGeneration]);
const [recoveryReturnRequest, setRecoveryReturnRequest] = useState(0);
const [userData, setUserData] = useState(null);
const [loginError, setLoginError] = useState('');
// Sabitler
const DEFAULT_AVATAR = '/default-avatar.png';
//Kullanıcı Bilgileri devam
const [profileImage, setProfileImage] = useState(() => {
  const saved = sessionStorage.getItem(`profileImage_${username}`);
  return saved || DEFAULT_AVATAR;
});
const [infoMessage, setInfoMessage] = useState('');
//Ekran ve geçiş yönetimi
const [currentScreen, setCurrentScreen] = useState(() => {
  const saved = sessionStorage.getItem('currentScreen');
  const savedGameOverData = sessionStorage.getItem('gameOverData');
  const validScreens = ['login', 'register', 'start', 'game', 'gameOver', 'newMatch', 'myGames', 'social', 'achievements','daily','market'];

  if (saved === 'game' && savedGameOverData) {
    console.warn('[INIT] Oyun bitmişti, gameOver ekranına dönülüyor.');
    return 'gameOver';
  }

  // A missing result cannot render GameOverScreen. This state can survive F5
  // when result data was cleared during a game transition.
  if (saved === 'gameOver' && !savedGameOverData) {
    return resolveResultScreen(saved, null, sessionStorage.getItem('username'), sessionStorage.getItem('gameId'));
  }

  if (sessionStorage.getItem('reconnectToken') && (!saved || ['login', 'register'].includes(saved))) return 'start';
  return validScreens.includes(saved) ? saved : 'login';
});

useEffect(()=>{recordConnectionEvent('client-loaded',{clientVersion:'v227',viewportWidth:window.innerWidth,viewportHeight:window.innerHeight,standalone:window.matchMedia('(display-mode: standalone)').matches||navigator.standalone===true});},[]);

//Oyun verileri
const [board, setBoard] = useState(Array(5).fill(null).map(() => Array(5).fill('')));
const [ownLetterDraft, setOwnLetterDraft] = useState(null);
const [turnData, setTurnData] = useState(null);
// WebSocket handler is installed once; sound decisions must read live UI state.
const soundScreenRef = useRef(currentScreen);
const soundTurnRef = useRef(null);
soundScreenRef.current = currentScreen;
soundTurnRef.current = turnData;
const [scores, setScores] = useState({ myScore: 0, opponentScore: 0 });
const [newAchievements, setNewAchievements] = useState([]);
const achievementBaselineRef = useRef(null);
const achievementGameRef = useRef(null);
const shownAchievementsRef = useRef(new Set());
const [validWordCells, setValidWordCells] = useState([]);
const [statusMessage, setStatusMessage] = useState('');
useEffect(() => {
  document.documentElement.dataset.experienceScreen=currentScreen;
  recordConnectionEvent('screen', { screen: currentScreen });
}, [currentScreen]);
useEffect(() => {
  const onVisibility = () => recordConnectionEvent('visibility', {
    state: document.visibilityState,
    screen: sessionStorage.getItem('currentScreen') || 'unknown',
    socket: socketRef.current?.readyState ?? null,
  });
  document.addEventListener('visibilitychange', onVisibility);
  return () => document.removeEventListener('visibilitychange', onVisibility);
}, []);
// Informational banners expire; connection failures remain visible until recovery.
useEffect(() => {
  if (!statusMessage || /Bağlantı kesildi|tekrar bağlanılıyor|Bir hata oluştu/.test(statusMessage)) return;
  const timeout = window.setTimeout(() => setStatusMessage(current => current === statusMessage ? '' : current),
    statusMessage.includes('bekleyen oyun davetin') ? 10000 : 5000);
  return () => window.clearTimeout(timeout);
}, [statusMessage]);
const [gameDuel,setGameDuel]=useState(null);
const [gameId, setGameId] = useState(null);
const visibleGameRef = useRef(null); visibleGameRef.current = gameId;
const acceptedWhilePlayingRef = useRef(new Set());
const [resultNotices,setResultNotices] = useState([]);
useEffect(()=>setResultNotices([]),[username]);
const [isReconnect, setIsReconnect] = useState(false);
const [activeGamesState, _setActiveGamesState] = useState([]);
const pendingJoinGameRef = useRef(null);
const pendingJoinSinceRef = useRef(0);
const pendingJoinRetriesRef = useRef(0);
const pendingSocialLoginRef = useRef(null);
const authenticatedUsernameRef = useRef('');


const setActiveGames = (data) => {
  try {
    // React state güncellemesini kopya alarak yap
    _setActiveGamesState([...data]); 
  } catch (err) {
    console.error('[ERROR] setActiveGames failed:', err, data);
  }
};
// Oyun sonu
const [gameOverData, setGameOverDataState] = useState(() => {
  let savedGameOver = null;
  try {
    const saved = sessionStorage.getItem('gameOverData');
    savedGameOver = saved ? JSON.parse(saved) : null;
  } catch (e) {
    console.warn('[WARN] Bozuk gameOverData JSON:', e);
    savedGameOver = null;
  }
  return savedGameOver;
});
// Socket callbacks outlive the render that created them. Keep result ownership
// current synchronously, including start/turn messages arriving in one batch.
const gameOverDataRef = useRef(gameOverData);
const setGameOverData = value => {
  gameOverDataRef.current = value;
  setGameOverDataState(value);
};
const [rematchPending, setRematchPending] = useState(false);
const [matchClockHours, setMatchClockHours] = useState(null);
const matchClockRef = useRef(null);
const [clockSpec, setClockSpec] = useState(null);
const [botDifficulty,setBotDifficulty] = useState(null);
const clockSpecRef = useRef(null);
const [acceptSent, setAcceptSent] = useState(false);

//Rakip verileri
const [opponentUsername, setOpponentUsername] = useState('');
const [opponentImage, setOpponentImage] = useState('');
const opponentUsernameRef = useRef('');

//İstatistik ve Geçmiş
const [totalGames, setTotalGames] = useState(() => {
const saved = sessionStorage.getItem('totalGames');
  return saved ? parseInt(saved, 10) : 0;
});
const [wins, setWins] = useState(() => {
  const saved = sessionStorage.getItem('wins');
  return saved ? parseInt(saved, 10) : 0;
});
const careerStatsRef = useRef({ totalGames, wins });
const [losses, setLosses] = useState(() => {
  const saved = sessionStorage.getItem('losses');
  return saved ? parseInt(saved, 10) : 0;
});
const [recentGames, setRecentGames] = useState([]);
const [careerWinRate, setCareerWinRate] = useState(0);
const [careerAverageScore, setCareerAverageScore] = useState(0);

//Davet
const [chats, setChats] = useState({});
const [social, setSocial] = useState({ friends: [], incoming: [], outgoing: [], invites: [], notices: [] });
const [socialSearchResults, setSocialSearchResults] = useState([]);
const socialSearchQueryRef=useRef('');
const [friendActionError, setFriendActionError] = useState('');
const { rematchMessage } = require('./utils/opponentActions');
const sendFriendAction = (action, target) => {
  setFriendActionError('');
  if (socketRef.current?.readyState !== WebSocket.OPEN) { setFriendActionError('Bağlantı hazır değil. Tekrar dene.'); return false; }
  socketRef.current.send(JSON.stringify({ type: 'socialAct', action, target }));
  return true;
};
const [socialSection, setSocialSection] = useState('friends');
const [socialInvitee, setSocialInvitee] = useState('');
const knownFriendRequestsRef = useRef(null);
const seenSocialNoticesRef = useRef(new Set());
const socialSeenOwnerRef=useRef('');
const [socialAlert,setSocialAlert] = useState(null);
const rememberSocialAlert=alert=>{
  if(!alert||alert.owner!==authenticatedUsernameRef.current)return;
  const seen=readSeen(localStorage,alert.owner);
  for(const item of [...alert.requests,...alert.accepted])seen.add(item.key);
  writeSeen(localStorage,alert.owner,seen);
};
const [socialActionResult,setSocialActionResult] = useState(null);
const [socialActionError,setSocialActionError] = useState(null);
useEffect(()=>{seenSocialNoticesRef.current=new Set();setSocialAlert(null);setSocialActionResult(null);setSocialActionError(null);},[authenticatedSessionGeneration]);
const [myGamesInitialTab, setMyGamesInitialTab] = useState(initialOnlineOptions?.tab || 'active');
useLayoutEffect(()=>{
  const {cachedTheme,applyScreenTheme}=require('./utils/screenTheme');
  applyScreenTheme(null,cachedTheme(username));
  if(!username||!sessionStorage.getItem('reconnectToken'))return;
  let alive=true,changed=false;
  const apply=e=>{changed=true;applyScreenTheme(username,e.detail);};
  window.addEventListener('kelimo-screen-theme',apply);
  fetch(getApiUrl(`/market?username=${encodeURIComponent(username)}`),{headers:require('./utils/accountFetch').accountHeaders(),cache:'no-store'}).then(r=>r.ok?r.json():null).then(d=>{if(alive&&!changed&&d)applyScreenTheme(username,d.theme);}).catch(()=>{});
  return()=>{alive=false;window.removeEventListener('kelimo-screen-theme',apply);};
},[username]);
const notificationOpenRef = useRef(0);
const resumeNotificationRef = useRef(false);
const dismissedResumeGameRef = useRef(null);
const [homeResumeGeneration,setHomeResumeGeneration] = useState(0);
async function openNotificationGame(destination, account) {
  resumeNotificationRef.current = true;
  const request = ++notificationOpenRef.current;
  const result = destination.kind === 'result' || destination.tab === 'finished';
  pendingJoinGameRef.current = null;
  if (result) { sessionStorage.removeItem('gameId'); setGameId(null); setMyGamesInitialTab('finished'); setCurrentScreen('myGames'); }
  setStatusMessage('Maç açılıyor…');
  const controller = new AbortController();
  let timer;
  try {
    const timeout = new Promise((_, reject) => { timer = setTimeout(() => { controller.abort(); reject(Error('timeout')); }, 8000); });
    const response = await Promise.race([fetch(getApiUrl(`/get-finished-game?username=${encodeURIComponent(account)}&gameId=${encodeURIComponent(destination.gameId)}`), {headers: accountHeaders(), cache:'no-store', signal:controller.signal}), timeout]);
    if (request !== notificationOpenRef.current || authenticatedUsernameRef.current !== account) return;
    if (response.ok) {
      const record = await Promise.race([response.json(), timeout]);
      if (request !== notificationOpenRef.current || authenticatedUsernameRef.current !== account) return;
      const detail = require('./utils/finishedNotification').finishedNotificationDetail(record, account);
      if(destination.celebrate)detail.fromHistory=false;
      require('./utils/finishedDetailSession').persistFinishedDetail(sessionStorage, detail);
      setGameId(null); setGameOverData(detail); setCurrentScreen('gameOver'); setStatusMessage('');
    } else if (response.status === 404 && !result) joinGame({gameId:destination.gameId});
    else { setMyGamesInitialTab('finished'); setCurrentScreen('myGames'); setStatusMessage('Bu maçın sonucu açılamadı. Biten Oyunlar’dan tekrar deneyebilirsin.'); }
  } catch (_) {
    if (request === notificationOpenRef.current && authenticatedUsernameRef.current === account) { setMyGamesInitialTab(result ? 'finished' : 'active'); setCurrentScreen('myGames'); setStatusMessage('Bağlantı bekledi. Maçı yeniden açmayı deneyebilirsin.'); }
  } finally { clearTimeout(timer); }
}

useEffect(() => {
  if (!authenticatedSessionGeneration) return undefined;
  const account = authenticatedUsernameRef.current, token = sessionStorage.getItem('reconnectToken');
  return connectNativeLinks({ username: account, token, onOpen: destination => {
    if (authenticatedUsernameRef.current !== account) return;
    resumeNotificationRef.current = true;
    if (destination.tab === 'friends') { setSocialSection('friends'); setCurrentScreen('social'); return; }
    setMyGamesInitialTab(destination.tab); setCurrentScreen('myGames');
    setStatusMessage('İlgili oyunu bu bölümden açabilirsin.');
  } });
}, [authenticatedSessionGeneration]);
useEffect(() => {
  const account = authenticatedUsernameRef.current;
  const token = sessionStorage.getItem('reconnectToken');
  if (!account || !token) return undefined;
  let cancelled = false;
  let stop = () => {};
  connectNativePush({ username: account, token, onOpen: destination => {
    if (cancelled || authenticatedUsernameRef.current !== account) return;
    resumeNotificationRef.current = true;
    if (destination.tab === 'friends') { setSocialSection('friends'); setCurrentScreen('social'); return; }
    if (destination.gameId && ['active','finished'].includes(destination.tab)) { void openNotificationGame(destination, account); return; }
    if(destination.tab==='invites')setPushInviteId(destination.gameId||null);
    setMyGamesInitialTab(destination.tab);
    setCurrentScreen('myGames');
    setStatusMessage(destination.tab === 'invites' ? 'Davetler bölümünden oyun davetini aç.' : destination.tab === 'finished' ? 'Biten Oyunlar bölümünden maç sonucunu aç.' : 'Devam Eden Oyunlar bölümünden ilgili oyunu aç.');
  } }).then(cleanup => { if (cancelled) cleanup(); else stop = cleanup; })
    .catch(error => console.warn('[PUSH] Cihaz bağlantısı kurulamadı:', error));
  return () => { cancelled = true; stop(); };
}, [authenticatedSessionGeneration]);
useEffect(() => {
  if (!authenticatedSessionGeneration || !authenticatedUsernameRef.current) return;
  const account = authenticatedUsernameRef.current, token = sessionStorage.getItem('reconnectToken');
  const open = destination => {
    if (authenticatedUsernameRef.current !== account || !destination) return;
    resumeNotificationRef.current = true;
    if (['turn', 'time', 'result'].includes(destination.kind)) void openNotificationGame(destination, account);
    else if (destination.kind === 'invite') {
      setMyGamesInitialTab('invites'); setPushInviteId(destination.gameId); setCurrentScreen('myGames');
      safeSend({ type: 'socialGet' });
    } else { setSocialSection('friends'); setCurrentScreen('social'); safeSend({ type: 'socialGet' }); }
  };
  let stopped = false, cleanup = () => {};
  connectWebPush(account, token, open).then(stop => { if (stopped) stop(); else cleanup = stop; }).catch(() => {});
  return () => { stopped = true; cleanup(); };
}, [authenticatedSessionGeneration]);
useEffect(()=>{const account=authenticatedUsernameRef.current;if(!account||!authenticatedSessionGeneration)return;prepareOfflineProfile(account).catch(()=>{});flushSuggestions(account).catch(()=>{});},[authenticatedSessionGeneration,profileImage,careerWinRate,careerAverageScore]);
useEffect(()=>{const refresh=event=>{const account=authenticatedUsernameRef.current;if(account&&event.detail?.username?.toLowerCase()===account.toLowerCase())prepareOfflineProfile(account).catch(()=>{});};window.addEventListener('kelimo-cosmetics-updated',refresh);window.addEventListener('kelimo-badges-updated',refresh);return()=>{window.removeEventListener('kelimo-cosmetics-updated',refresh);window.removeEventListener('kelimo-badges-updated',refresh);};},[authenticatedSessionGeneration]);
const [pushInviteId, setPushInviteId] = useState(null);
const [invitePopup, setInvitePopup] = useState({ visible: false, id: null, from: null, turnDurationHours: null });
const invitePopupRef = useRef(invitePopup);
useEffect(() => { invitePopupRef.current = invitePopup; }, [invitePopup]);

//Sistem, Socket ve Bağlantı
const [onlineCount, setOnlineCount] = useState(0);
const socketRef = useRef(null);
const reconnectAttemptsRef = useRef(0);
const reconnectTimeoutRef = useRef(null);
const [connectionState, setConnectionState] = useState('connecting');
const [connectionRequest,setConnectionRequest]=useState(0);
const [dailyTransportIssue,setDailyTransportIssue]=useState(false);
function requireConnection(){
 if(navigator.onLine!==false&&connectionState==='ready'&&socketRef.current?.readyState===WebSocket.OPEN&&socketRef.current?.authenticated===true)return true;
 setConnectionRequest(n=>n+1);return false;
}

//Zamanlayıcı Sistemi
const { timer, startTimer, stopTimer } = useTimer();

const applyCareerStats = (stats = {}) => {
  const updated = { totalGames: Number(stats.totalGames) || 0, wins: Number(stats.wins) || 0,
    bestWinStreak: Number(stats.bestWinStreak) || 0, bestScore: Number(stats.bestScore) || 0 };
  if (achievementGameRef.current && achievementBaselineRef.current) {
    const fresh = unlockedBetween(achievementBaselineRef.current, updated).filter(item => {
      const key = `${achievementGameRef.current}:${item.id}`;
      if (shownAchievementsRef.current.has(key)) return false;
      shownAchievementsRef.current.add(key);
      return true;
    });
    if (fresh.length) setNewAchievements(current => [...current, ...fresh]);
  }
  careerStatsRef.current = updated;
  setTotalGames(Number(stats.totalGames) || 0);
  setWins(Number(stats.wins) || 0);
  setLosses(Number(stats.losses) || 0);
  setCareerWinRate(Number(stats.winRate) || 0);
  setCareerAverageScore(Number(stats.averageScore) || 0);
};

const fetchCareerStats = (targetUsername) => {
  if (!targetUsername) return Promise.resolve();
  return fetch(`/get-player-stats?username=${encodeURIComponent(targetUsername)}`)
    .then(response => {
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      return response.json();
    })
    .then(applyCareerStats)
    .catch(error => console.error('Kariyer istatistikleri alınamadı:', error));
};

// 👤 Profil / Avatar işlemleri
function handleAvatarChange(imgUrl) {
  setProfileImage(imgUrl);
  sessionStorage.setItem(`profileImage_${username}`, imgUrl);

  if (socketRef.current && socketRef.current.readyState === WebSocket.OPEN) {
    console.log('[WS SEND] updateProfileImage', { profileImage: imgUrl });

    socketRef.current.send(JSON.stringify({
      type: 'updateProfileImage',
      profileImage: imgUrl,
    }));
  }
}

// 🔐 Kullanıcı login işlemi
function handleLogin(u, p) {
  setLoginError('');
  if (!socketRef.current || socketRef.current.readyState !== 1) {
    console.warn('WebSocket bağlantısı henüz hazır değil.');
    return;
  }
  socketRef.current.send(JSON.stringify({
  type: 'login',
  username: u,
  password: p,
  isReconnect: false // 🔐 manuel giriş → reconnect değil
}));
}

async function handleGoogleCredential(idToken) {
  setLoginError('');
  try {
    const response = await fetch(getApiUrl('/google-login'), {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ idToken }),
    });
    const result = await response.json();
    if (!response.ok) throw new Error(result.message || 'Google girişi başarısız.');
    if (!result.username || !result.reconnectToken) throw new Error('Google oturumu eksik döndü.');
    // The browser may reconnect while Google's account picker is open.
    let socket = socketRef.current;
    for (let attempt = 0; socket?.readyState !== WebSocket.OPEN && attempt < 30; attempt++) {
      await new Promise(resolve => setTimeout(resolve, 200));
      socket = socketRef.current;
    }
    if (socket?.readyState !== WebSocket.OPEN) throw new Error('Oyun bağlantısı kurulamadı. Tekrar dene.');
    pendingSocialLoginRef.current = result.username.toLowerCase();
    socket.send(JSON.stringify({
      type: 'login', username: result.username, reconnectToken: result.reconnectToken,
      isReconnect: true, gameId: null,
    }));
  } catch (error) {
    pendingSocialLoginRef.current = null;
    setLoginError(error.message || 'Google girişi başarısız.');
  }
}
async function handleFacebookCredential(accessToken) {
  setLoginError('');
  if (socketRef.current?.readyState !== WebSocket.OPEN) {
    setLoginError('Bağlantı hazır değil. Birkaç saniye sonra tekrar dene.');
    return;
  }
  try {
    const response = await fetch(getApiUrl('/facebook-login'), {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ accessToken }),
    });
    const result = await response.json();
    if (!response.ok) throw new Error(result.message || 'Facebook girişi başarısız.');
    if (!result.username || !result.reconnectToken) throw new Error('Facebook oturumu eksik döndü.');
    pendingSocialLoginRef.current = result.username.toLowerCase();
    socketRef.current.send(JSON.stringify({
      type: 'login', username: result.username, reconnectToken: result.reconnectToken,
      isReconnect: true, gameId: null,
    }));
  } catch (error) {
    pendingSocialLoginRef.current = null;
    setLoginError(error.message || 'Facebook girişi başarısız.');
  }
}
async function handleAppleCredential(credential) {
  setLoginError('');
  try {
    const response = await fetch(getApiUrl('/apple-login'), {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(credential),
    });
    const result = await response.json();
    if (!response.ok) throw Error(result.message || 'Apple girişi başarısız.');
    if (!result.username || !result.reconnectToken) throw Error('Apple oturumu eksik döndü.');
    let socket = socketRef.current;
    for (let attempt = 0; socket?.readyState !== WebSocket.OPEN && attempt < 30; attempt++) {
      await new Promise(resolve => setTimeout(resolve, 200)); socket = socketRef.current;
    }
    if (socket?.readyState !== WebSocket.OPEN) throw Error('Oyun bağlantısı kurulamadı. Tekrar dene.');
    pendingSocialLoginRef.current = result.username.toLowerCase();
    socket.send(JSON.stringify({ type: 'login', username: result.username, reconnectToken: result.reconnectToken, isReconnect: true, gameId: null }));
  } catch (error) { pendingSocialLoginRef.current = null; setLoginError(error.message || 'Apple girişi başarısız.'); }
}
useEffect(()=>{
 const openRound=event=>{const series=event.detail,actor=authenticatedUsernameRef.current;
  if(!actor||series?.phase!=='playing'||!series.current||!series.players.includes(actor))return;
  if(Number(sessionStorage.getItem(`duelReady:${actor}:${series.id}`))!==series.current.number)return;
  if(sessionStorage.getItem('gameId')===series.current.gameId||pendingJoinGameRef.current===series.current.gameId)return;
  joinGame({gameId:series.current.gameId});
 };
 window.addEventListener('kelimo-duel-updated',openRound);window.addEventListener('kelimo-duel-round-available',openRound);
 return()=>{window.removeEventListener('kelimo-duel-updated',openRound);window.removeEventListener('kelimo-duel-round-available',openRound);};
},[username,authenticatedSessionGeneration]);
function joinGame(game) {
  if(game?.local){onOffline({resumeGameId:game.gameId,username:authenticatedUsernameRef.current});return;}
  if (!game) {
    console.warn('[WARN] joinGame null veya undefined game aldı');
    return; // game yoksa fonksiyon burada durur
  }

  if (!game.gameId) return;
  dismissedResumeGameRef.current = null;
  pendingJoinGameRef.current = game.gameId;
  pendingJoinSinceRef.current = Date.now(); pendingJoinRetriesRef.current = 0;
  setStatusMessage('Oyun açılıyor…');
  console.log('[App.js] joinGame çağrıldı:', game.gameId);

  const normalizedUsername = username?.toLowerCase();
  const socketReady = socketRef.current && socketRef.current.readyState === WebSocket.OPEN;
  const authenticated = authenticatedUsernameRef.current === normalizedUsername && socketRef.current?.authenticated === true;

  if (socketReady && authenticated) {
    console.log('[CLIENT][JOIN] joinGame mesajı gönderiliyor:', game.gameId);
    socketRef.current.send(JSON.stringify({ type: 'joinGame', gameId: game.gameId }));
  } else {
    // Reconnect/login henüz tamamlanmadıysa tıklamayı kaybetme. loginSuccess gelince gönderilecek.
    pendingJoinGameRef.current = game.gameId;
    setConnectionRequest(n=>n+1);
    console.warn('[CLIENT][JOIN] WebSocket henüz authenticated değil; join kuyruğa alındı:', game.gameId);
  }
}

// ♻️ Oyun sıfırlama
const resetGameState = () => {
  console.log('--- resetGameState başlatıldı ---');
  setBoard(Array(5).fill(null).map(() => Array(5).fill('')));
  setOwnLetterDraft(null);
  setScores({ myScore: 0, opponentScore: 0 });
  setTurnData(null);
  setMatchClockHours(null);
  matchClockRef.current = null;
  setGameOverData(null);
  setStatusMessage('');
sessionStorage.removeItem('gameOverData');

};

// 🔁 Rematch
const handleRematch = (opponentUsername) => {
  if (!opponentUsername) {
    console.warn('[WARN] opponentUsername bilinmiyor, rematch gönderilemez.');
    return;
  }

  console.log('[DEBUG] Rematch isteği gönderiliyor:', opponentUsername);

  socketRef.current.send(JSON.stringify({
    type: 'invite',
    to: opponentUsername,
    fromRematch: true,
    boardSize: gameOverData?.boardSize || 5
  }));

  setRematchPending(true); // ✅ App.js içinde tanımlı olan state
};
function safeSend(message) {
  if (socketRef.current && socketRef.current.readyState === WebSocket.OPEN) {
    console.log('[WS SEND] Gönderilen mesaj:', message);
    socketRef.current.send(JSON.stringify(message));
  } else {
    console.warn('WebSocket bağlantısı açık değil, mesaj gönderilemiyor:', message);
    // Burada istersen mesajı bir kuyrukta tutup bağlantı açılınca gönderebilirsin
  }
}
function sendChatMessage(gameId, text) {
  if (!socketRef.current || socketRef.current.readyState !== WebSocket.OPEN) return false;
  socketRef.current.send(JSON.stringify({ type: 'chatSend', gameId, text }));
  return true;
}
function fetchActiveGames(currentUsername) {
  if (!currentUsername) return;
  fetch(`/get-active-games?username=${encodeURIComponent(currentUsername)}`, { headers: accountHeaders() })
    .then(res => {
      if (!res.ok) throw new Error(`HTTP hatası! Status: ${res.status}`);
      return res.json();
    })
    .then(data => setActiveGames(data))
    .catch(err => console.error('Aktif oyunlar alınamadı:', err));
}


// A revoked session must clear the visible account as well as credentials.
function expireAccountSession(message = 'Oturumun sona erdi. Yeniden giriş yap.') {
  if (reconnectTimeoutRef.current) clearTimeout(reconnectTimeoutRef.current);
  reconnectTimeoutRef.current = null;
  reconnectAttemptsRef.current = 0;
  void disconnectWebPush(sessionStorage.getItem('username'), sessionStorage.getItem('reconnectToken')).catch(() => {});
  forgetSession(sessionStorage, localStorage);
  authenticatedUsernameRef.current = '';
  pendingJoinGameRef.current = null;
  pendingSocialLoginRef.current = null;
  knownFriendRequestsRef.current = null;
  for (const key of ['username', 'reconnectToken', 'gameId', 'gameOverData', 'currentScreen', 'totalGames', 'wins', 'losses']) sessionStorage.removeItem(key);
  setUsername('');
  setUserData(null);
  setAuthenticatedSessionGeneration(value => value + 1);
  setChats({});
  setSocial({ friends: [], incoming: [], outgoing: [], invites: [], notices: [] });
  setSocialSearchResults([]);
  setSocialInvitee('');
  setActiveGames([]);
  setInvitePopup({ visible: false, id: null, from: null, turnDurationHours: null });
  setRematchPending(false);
  setGameId(null);
  opponentUsernameRef.current = '';
  setOpponentUsername('');
  resetGameState();
  setProfileImage(DEFAULT_AVATAR);
  setRecentGames([]);
  setTotalGames(0);
  setWins(0);
  setLosses(0);
  setCareerWinRate(0);
  setCareerAverageScore(0);
  setLoginError('');
  setInfoMessage(message);
  setCurrentScreen('login');
  localStorage.removeItem('kelimoOfflineActive');
  window.dispatchEvent(new Event('kelimo-session-ended'));
}

// 🌐 WebSocket bağlantısını başlat
function renewWebSocket(details = {}) {
  recordConnectionEvent('socket-renew', {reason: typeof details.reason === 'string' ? details.reason : 'manual', awayMs: details.awayMs, socket:socketRef.current?.readyState ?? null, screen:soundScreenRef.current});
  if (reconnectTimeoutRef.current) clearTimeout(reconnectTimeoutRef.current);
  reconnectTimeoutRef.current = null;
  reconnectAttemptsRef.current = 0;
  const previous = socketRef.current;
  socketRef.current = null;
  if (previous) { previous.authenticated = false; previous.close(); }
  initializeWebSocket();
}
function initializeWebSocket() {
 if (navigator.onLine === false) { setConnectionState('offline'); return; }
 const existing = socketRef.current;
 if (existing && (existing.readyState === WebSocket.CONNECTING || existing.readyState === WebSocket.OPEN)) return;
 setConnectionState('connecting');
 const socket = new WebSocket(getWebSocketUrl());
  socket.authenticated = false;
  socket.createdAt = Date.now();
  socket.lastMessageAt = Date.now();
  socketRef.current = socket;

  socket.onopen = () => {
  if (socketRef.current !== socket) { socket.close(); return; }
  if (reconnectTimeoutRef.current) clearTimeout(reconnectTimeoutRef.current);
  reconnectTimeoutRef.current = null;
  socket.openedAt = Date.now();
  socket.lastPresenceAck = Date.now();
  recordConnectionEvent('socket-open', { screen: sessionStorage.getItem('currentScreen') || 'unknown' });
  setStatusMessage(current => /Bağlantı kesildi|tekrar bağlanılıyor|Bir hata oluştu/.test(current) ? '' : current);
    
    console.log('✅ WebSocket bağlantısı kuruldu.');
  const storedUsername = sessionStorage.getItem('username');
  const storedReconnectToken = sessionStorage.getItem('reconnectToken');
  if (storedUsername && storedReconnectToken) {
    setConnectionState('authenticating');
    console.log('[Reconnect] Otomatik login atılıyor:', storedUsername);
    const savedScreen = sessionStorage.getItem('currentScreen');
    const storedGameId = savedScreen === 'game' ? sessionStorage.getItem('gameId') : null;
    safeSend({
      type: 'login',
      username: storedUsername,
      reconnectToken: storedReconnectToken,
      isReconnect: true,
      gameId: storedGameId || null
    });
  } else if (storedUsername) {
    setConnectionState('ready');
    console.warn('[Reconnect] Geçerli reconnect token yok; yeniden manuel giriş gerekli.');
    sessionStorage.removeItem('username');
    sessionStorage.removeItem('gameId');
    setUsername('');
    setCurrentScreen('login');
  } else {
    reconnectAttemptsRef.current = 0;
    setConnectionState('ready');
  }
};
socket.onmessage = (event) => {
if (socketRef.current !== socket) return;
socket.lastMessageAt = Date.now();
if (!event.data) {
    console.warn('[WS] Boş mesaj geldi, işlenmiyor.');
    return;
  }  
let data;
try {
  data = JSON.parse(event.data);
} catch (e) {
  console.error('[WS] JSON parse hatası:', e);
  return;
}
 if (!data.type) {
    console.warn('[WS] Tipi olmayan mesaj alındı.');
    return;
  }

  // v76 telemetry only: acknowledge what this browser actually received.
  // Sent after receipt; server ignores clientTelemetry for gameplay.
  if (socket.readyState === WebSocket.OPEN && data.type !== 'clientTelemetry') {
    socket.send(JSON.stringify({
      type: 'clientTelemetry',
      event: 'CLIENT_RECEIVED',
      receivedType: data.type,
      gameId: data.gameId || sessionStorage.getItem('gameId') || null,
      screen: sessionStorage.getItem('currentScreen') || null,
      clientTs: new Date().toISOString()
    }));
  }


  // Eğer JSON-RPC hatası varsa
  try {
  if (data.error) {
    console.error('[WS] JSON-RPC Hatası:', data.error);
  }
} catch (err) {
  console.error('[WS] Error loglanırken patladı:', err);
}

if (['turn','boardState','ownLetterDraft','scoreUpdate'].includes(data.type) && data.gameId && data.gameId!==visibleGameRef.current) return;
switch (data.type) {

case 'loginSuccess':
  socket.authenticated = true;
  socket.lastPresenceAck = Date.now();
  reconnectAttemptsRef.current = 0;
  setConnectionState('ready');
  setStatusMessage(current => /Bağlantı kesildi|tekrar bağlanılıyor|Bir hata oluştu/.test(current) ? '' : current);
  if (pendingSocialLoginRef.current === data.username?.toLowerCase()) {
    pendingSocialLoginRef.current = null;
    setCurrentScreen('start');
  }
  recordConnectionEvent('login-success', { reconnect: Boolean(data.isReconnect) });
  knownFriendRequestsRef.current = null;
  console.log('loginSuccess alındı, startScreen açılıyor...');
  setLoginError('');
  const lowerUsername = data.username.toLowerCase();
  const loginPhoto=data.profileImage||sessionStorage.getItem(`profileImage_${lowerUsername}`)||DEFAULT_AVATAR;
  setProfileImage(loginPhoto);
  sessionStorage.setItem(`profileImage_${lowerUsername}`,loginPhoto);
  seedIdentity(lowerUsername,{profileImage:loginPhoto,...(data.displayName?{displayName:data.displayName}:{})});
  void loadIdentity(lowerUsername,{force:true,token:data});
  setUsername(lowerUsername);
  console.log('[DEBUG] setUsername loginSuccess ile çağrıldı:', lowerUsername);
  sessionStorage.setItem('username', lowerUsername); // yeni satır
  authenticatedUsernameRef.current = lowerUsername;
  if (pendingJoinGameRef.current && socketRef.current?.readyState === WebSocket.OPEN) {
    const pendingGameId = pendingJoinGameRef.current;
    pendingJoinSinceRef.current = Date.now();
    console.log('[CLIENT][JOIN] loginSuccess sonrası bekleyen join gönderiliyor:', pendingGameId);
    socketRef.current.send(JSON.stringify({ type: 'joinGame', gameId: pendingGameId }));
  }
  if (data.reconnectToken) {
    sessionStorage.setItem('reconnectToken', data.reconnectToken);
  }
  persistSession(sessionStorage, localStorage);
  window.dispatchEvent(new Event('kelimo-session-ready'));
  setAuthenticatedSessionGeneration(current => current + 1);

  setUserData({
    username: lowerUsername,
    dictionaryAdminEnabled: data.dictionaryAdminEnabled === true,
    winRate: data.winRate ?? 0,
    averageScore: data.averageScore ?? 0,
    wins: data.wins ?? 0,
    losses: data.losses ?? 0
  });
  applyCareerStats(data);
  safeSend({ type: 'socialGet' });

const gamesList = Array.isArray(data.activeGames) ? data.activeGames : [];
setActiveGames(gamesList.filter(g => g?.status === 'ongoing'));

  const pendingInviteCount = Number(data.pendingInviteCount || 0);
  if (pendingInviteCount > 0) {
    setStatusMessage(
      pendingInviteCount === 1
        ? '1 bekleyen oyun davetin var. Oyunlarım > Davetler bölümünden görebilirsin.'
        : `${pendingInviteCount} bekleyen oyun davetin var. Oyunlarım > Davetler bölümünden görebilirsin.`
    );
  }

  // Automatic reconnect must preserve non-game navigation (e.g. Oyunlarım).
  // A manual login still lands on the start screen. Game reconnect is restored by the
  // authoritative `start` message that follows loginSuccess.
  if (consumeRecoveryReturn(sessionStorage, lowerUsername)) {
    setRecoveryReturnRequest(current => current + 1);
    setCurrentScreen('start');
  } else if (!data.isReconnect) {
    setCurrentScreen('start');
  }
  break;

case 'chatSnapshot':
  setChats(current => ({ ...current, [data.gameId]: mergeChatSnapshot(current[data.gameId], data) }));
  break;
case 'chatMessage':
  setChats(current => {
    const chat = current[data.gameId] || { messages: [], unread: 0 };
    if (chat.messages.some(message => message.id === data.message?.id)) return current;
    return { ...current, [data.gameId]: { ...chat, messages: [...chat.messages, data.message], error: data.message?.from === authenticatedUsernameRef.current ? null : chat.error, unread: chat.unread + (data.message?.from === authenticatedUsernameRef.current ? 0 : 1) } };
  });
  break;
case 'chatMessageRemoved':
  setChats(current => applyRemovedMessage(current, data.message));
  break;
case 'chatReadState':
  setChats(current => ({ ...current, [data.gameId]: { ...(current[data.gameId] || { messages: [] }), unread: data.unread || 0 } }));
  break;
case 'chatError':
  if (data.gameId) setChats(current => ({ ...current, [data.gameId]: { ...(current[data.gameId] || { messages: [], unread: 0 }), error: { message: data.message, text: data.rejectedText, at: Date.now() } } }));
  setStatusMessage(data.message || 'Mesaj işlemi tamamlanamadı.');
  break;
case 'chatReportSuccess':
  setStatusMessage('Mesaj şikâyetin alındı.');
  break;
case 'profileNameUpdated':
  setSocial(current => ({ ...current, playerDisplayNames: { ...current.playerDisplayNames, [data.username]: data.displayName } }));
  window.dispatchEvent(new CustomEvent('kelimo-player-name-updated', { detail: { username: data.username, displayName: data.displayName } }));
  safeSend({ type: 'socialGet' });
  break;
case 'communityUpdated':
  window.dispatchEvent(new CustomEvent('kelimo-community-updated'));
  break;
case 'socialSnapshot':
  if (invitePopupRef.current.visible && invitePopupRef.current.id &&
      !(data.invites || []).some(invite => invite.id === invitePopupRef.current.id)) {
    invitePopupRef.current = { visible: false, id: null, from: null, turnDurationHours: null };
    setInvitePopup(invitePopupRef.current);
  }
  if (knownFriendRequestsRef.current !== null &&
      (data.incoming || []).some(item => !knownFriendRequestsRef.current.includes(item.from)) &&
      document.visibilityState === 'visible') playSoundEffect('friend');
  const alertOwner=authenticatedUsernameRef.current;
  if(socialSeenOwnerRef.current!==alertOwner){socialSeenOwnerRef.current=alertOwner;seenSocialNoticesRef.current=new Set();}
  const seen=readSeen(localStorage,alertOwner);
  for(const key of seenSocialNoticesRef.current)seen.add(key);
  setSocialAlert(previous=>reconcileSocialAlert(previous,data,alertOwner,seen).alert);
  const nextAlerts=reconcileSocialAlert(null,data,alertOwner,seen);
  seenSocialNoticesRef.current=nextAlerts.seen;
  knownFriendRequestsRef.current = (data.incoming || []).map(item => item.from);
  setFriendActionError('');
  setSocial({ playerAvatars: data.playerAvatars || {}, presence: data.presence || {}, playerDisplayNames: data.playerDisplayNames || {}, friends: data.friends || [], blocked: data.blocked || [], incoming: data.incoming || [], outgoing: data.outgoing || [], invites: data.invites || [], notices: data.notices || [] });
  break;
case 'inviteAccepted':
  if (document.visibilityState === 'visible') playSoundEffect('accepted');
  break;
case 'inviteResolved': {
  const keepGame = soundScreenRef.current === 'game' || Boolean(document.querySelector('.daily-playing')) || acceptedWhilePlayingRef.current.has(data.inviteId);
  acceptedWhilePlayingRef.current.delete(data.inviteId);
  if (invitePopupRef.current.id === data.inviteId) {
    invitePopupRef.current = {visible:false,id:null,from:null};
    setInvitePopup(invitePopupRef.current);
  }
  if (data.duelId) {
    if(data.accepted) window.dispatchEvent(new CustomEvent('kelimo-duel-accepted',{detail:data.duel}));
    if(!keepGame) {
      setMyGamesInitialTab('active');setCurrentScreen('myGames');
      if(data.accepted)fetch(getApiUrl('/duels/action'),{method:'POST',headers:{...require('./utils/accountFetch').accountHeaders(),'Content-Type':'application/json'},body:JSON.stringify({username:authenticatedUsernameRef.current,duelId:data.duelId,action:'ready',ready:true})}).then(r=>{if(!r.ok)throw Error();}).catch(()=>setStatusMessage('Düello Oyunlarım’da. Hazır durumunu kontrol et.'));
    }
  } else if(data.gameId && !keepGame) {
    pendingJoinGameRef.current = data.gameId;
    safeSend({type:'joinGame',gameId:data.gameId});
  }
  break;
}
case 'socialSearchResult':
  if(data.query!=null&&data.query!==socialSearchQueryRef.current)break;
  setSocialSearchResults(data.users || []);
  setSocial(current => ({ ...current, playerDisplayNames: { ...current.playerDisplayNames, ...data.playerDisplayNames },playerAvatars:{...current.playerAvatars,...data.playerAvatars} }));
  break;
case 'socialActionResult':
  setSocialAlert(current=>resolveSocialAlert(current,data.action,data.target));
  setSocialActionResult(data);
  break;
case 'socialError':
  setSocialActionError(data);
  setFriendActionError(data.message || 'İşlem tamamlanamadı.');
  setStatusMessage(data.message || 'İşlem tamamlanamadı.');
  break;
case 'loginFailure':
if (data.code === 'SESSION_EXPIRED') {
  recordConnectionEvent('session-expired', { screen: sessionStorage.getItem('currentScreen') || 'unknown' });
  expireAccountSession('Oturumun sona erdi. Yeniden giriş yap.');
  break;
}
pendingSocialLoginRef.current = null;
setLoginError(data.message || 'Geçersiz kullanıcı adı veya şifre.');
break;

case 'reconnectFailure':
  recordConnectionEvent('reconnect-failure');
  // A stale saved game must not strand the browser on an empty game screen.
  sessionStorage.removeItem('gameId');
  setGameId(null);
  setTurnData(null);
  setCurrentScreen('myGames');
  setStatusMessage(data.message || 'Oyun geri yüklenemedi. Aktif oyunlardan yeniden açabilirsin.');
  break;

case 'setUsernameAck':
console.log("✅ Kullanıcı adı sunucu tarafından onaylandı.");
break;

case 'status':
  if(data.inviteRequestId)window.dispatchEvent(new CustomEvent('kelimo-invite-feedback',{detail:{requestId:data.inviteRequestId,success:Boolean(data.inviteSent),message:data.message}}));
  console.log('[App.js] Status mesajı:', data.message);
  setStatusMessage(data.message);
  break;

case 'invite':
  setAcceptSent(false);
  console.log('[CLIENT DEBUG] Gelen davet kimden:', data.from);
  console.log('[CLIENT DEBUG] Benim kullanıcı adım:', username);

  if (!data.from) {
    console.warn('[CLIENT] 🚫 Gelen davet geçersiz, gönderici yok.');
    return;
  }

  
  const authenticatedUsername = authenticatedUsernameRef.current;
  if (!authenticatedUsername) {
    console.warn('[CLIENT] Giriş yapılmamış bağlantıya gelen davet gösterilmedi.');
    return;
  }

  if (data.from === authenticatedUsername) {
    console.warn('[CLIENT] 🚫 Kendi gönderdiğim davet, işlenmeyecek.');
    return;
  }

  console.log('[App.js] ✅ Davet geldi, popup açılıyor:', data);
  playSoundEffect('invite');
  safeSend({ type: 'socialGet' });
  setInvitePopup({ visible: true, id: data.id || null, from: data.from, fromDisplayName: data.fromDisplayName || data.from, turnDurationHours: data.turnDurationHours || null, clockSpec: data.clockSpec || null, boardSize: data.boardSize || 5, matchKind:data.matchKind||'single',matchMode:data.matchMode||'casual' });
  break;

case 'duelUpdated':
  window.dispatchEvent(new CustomEvent('kelimo-duel-realtime',{detail:data.duel}));
  window.dispatchEvent(new CustomEvent('kelimo-duel-updated',{detail:data.duel}));
  setGameDuel(current=>current?.id===data.duel?.id?data.duel:current);
  break;
case 'randomDuelMatched':
  window.dispatchEvent(new CustomEvent('kelimo-duel-updated',{detail:data.duel}));
  setCurrentScreen('myGames');
  setStatusMessage('Rakibin bulundu. Düelloya başlamak için ikiniz de Başla seçin.');
  break;
case 'presenceState':
  setSocial(current => ({ ...current, presence: data.presence || {} }));
  break;
case 'presenceAck':
  socket.lastPresenceAck = Date.now();
  break;
case 'onlineCount':
console.log('[WS] 🔢 Online kullanıcı sayısı mesajı alındı:', data.count);
setOnlineCount(data.count);
console.log('[App.js] 🔢 Online kullanıcı sayısı (state sonrası):', data.count);
break;

case 'badgesUpdated': { window.dispatchEvent(new CustomEvent('kelimo-badges-updated',{detail:{username:data.username}})); break; }
case 'coinsUpdated': { window.dispatchEvent(new CustomEvent('kelimo-coins-updated',{detail:{username:data.username}})); break; }
case 'cosmeticsUpdated': { notifyCosmetics(data.username,data.active||{}); break; }
case 'profileImageUpdated': {
  const updatedUsername = String(data.username || '').toLocaleLowerCase('tr-TR');
  const currentUsername = String(authenticatedUsernameRef.current || username || '').toLocaleLowerCase('tr-TR');
  const currentOpponent = String(opponentUsernameRef.current || '').toLocaleLowerCase('tr-TR');

  if (updatedUsername && updatedUsername === currentUsername) {
    setProfileImage(data.profileImage || DEFAULT_AVATAR);
    sessionStorage.setItem(`profileImage_${currentUsername}`, data.profileImage || DEFAULT_AVATAR);
  }
  if (updatedUsername && updatedUsername === currentOpponent) {
    setOpponentImage(data.profileImage || DEFAULT_AVATAR);
  }
  break;
}

case 'start':
  if (data.invite && document.querySelector('.daily-playing')) break;
  if (data.invite && soundScreenRef.current === 'game' && visibleGameRef.current && visibleGameRef.current !== data.gameId && pendingJoinGameRef.current !== data.gameId) {
    pendingJoinGameRef.current=visibleGameRef.current;
    safeSend({type:'joinGame',gameId:visibleGameRef.current});break;
  }
  if (!data.invite && !data.fromRematch && soundScreenRef.current !== 'game' && pendingJoinGameRef.current !== data.gameId) break;
  if (data.gameId === dismissedResumeGameRef.current && pendingJoinGameRef.current !== data.gameId) break;
  setGameDuel(data.duel||null);
  if(data.duel)sessionStorage.removeItem(`duelReady:${authenticatedUsernameRef.current}:${data.duel.id}`);
  pendingJoinGameRef.current = null;
  setStatusMessage('');
  recordConnectionEvent('game-start', { gameId: data.gameId, reconnect: Boolean(data.isReconnect || (!data.invite && !data.fromRematch)), preset: data.clockSpec?.preset || 'legacy', boardSize: data.boardSize, yourTurn: data.yourTurn === true, hadResult: Boolean(gameOverDataRef.current) });
  // Joining an active match also clears a previously viewed result.
  setGameOverData(null);
  sessionStorage.removeItem('gameOverData');
  console.log('[CLIENT] Yeni gameId alındı:', data.gameId); // <== BURAYA
  console.log('[CLIENT][RECONNECT] start mesajı geldi');
  console.log('[CLIENT][RECONNECT] yourTurn:', data.yourTurn);
  console.log('[CLIENT][RECONNECT] letterToPlace:', data.letterToPlace);

  console.log('[CLIENT][START] Gelen start verisi:', JSON.stringify(data, null, 2)); 

  if (data.gameId) {
    setGameId(data.gameId); // ✅ burada state'e yazılıyor
    sessionStorage.setItem('gameId', data.gameId);
  }

  // A start message is sent for a newly created or explicitly joined game.
  // The socket handler captures the screen from its first render, so reading
  // currentScreen here can incorrectly skip navigation after F5 + Ana Menü.
  setCurrentScreen('game');

  setOpponentImage(data?.opponentImage || DEFAULT_AVATAR);
  opponentUsernameRef.current = data?.opponentUsername || '';
  setOpponentUsername(data?.opponentUsername || '');
  
  const reconnect = !data.invite && !data.fromRematch;
  console.log('[CLIENT][APP] reconnect değeri:', reconnect);
  setIsReconnect(reconnect);

  if (!reconnect) {
    resetGameState();
  }
  setBoard(Array.from({ length: data.boardSize || 5 }, () => Array(data.boardSize || 5).fill('')));
  clockSpecRef.current = data.clockSpec || null;
  setClockSpec(clockSpecRef.current);
  setBotDifficulty(data.botDifficulty ?? null);
  matchClockRef.current = data.turnDurationHours ?? null;
  setMatchClockHours(matchClockRef.current);
  
  const initialTurnData = {
    yourTurn: data.yourTurn === true,
    letterToPlace: data.letterToPlace ?? null,
    turnStartTime: data.turnStartTime,
    turnDuration: data.turnDuration,
    joker:data.joker,rulesVersion:data.rulesVersion,matchMode:data.matchMode,
  };
  soundTurnRef.current = initialTurnData;
  setTurnData(initialTurnData);

  break;

case 'ownLetterDraft':
  setBoard(data.board);
  setOwnLetterDraft(data.placement || null);
  break;

case 'jokerResult':
  window.dispatchEvent(new CustomEvent('kelimo-joker-result',{detail:data}));
  break;
case 'boardState':
  if(data.joker)setTurnData(current=>({...current,joker:data.joker,matchMode:data.matchMode,rulesVersion:data.rulesVersion}));
  setBoard(data.board);
  setOwnLetterDraft(null);
  break;

case 'turn':
  console.log('[CLIENT] Gelen turn mesajı:', data);
  if (gameOverDataRef.current) {
    recordConnectionEvent('turn-ignored-finished', { gameId: gameOverDataRef.current.gameId });
    console.log('[turn] Oyun bitti, turn mesajı yoksayılıyor.');
    break;
  }
  recordConnectionEvent('turn-applied', { yourTurn: data.yourTurn === true, hasClocks: Boolean(data.clocks), mineMs: data.clocks?.mine?.remainingMs, opponentMs: data.clocks?.opponent?.remainingMs });
  if (data.yourTurn === true && soundScreenRef.current === 'game' && soundTurnRef.current?.yourTurn === false) playSoundEffect('turn');
  soundTurnRef.current = data;
  setTurnData({ ...data, clocks: data.clocks ? { ...data.clocks, receivedAt: Date.now() } : undefined });
  // Live turn messages synchronize state; they must not navigate a device that
  // is currently on Ana Menü/Oyunlarım into GameScreen.
  if (currentScreen === 'game') {
    console.log('[CLIENT][TURN] Açık oyun canlı olarak güncellendi.');
  } else {
    console.log('[CLIENT][TURN] Arka plan turn güncellemesi alındı; ekran korunuyor:', currentScreen);
  }

if (typeof data.remainingTime === 'number' && data.yourTurn === true) {

    const remainingSeconds = Math.floor(data.remainingTime / 1000);
    console.log('[CLIENT] ⏱ Timer başlatılıyor (zorla):', remainingSeconds);
    startTimer(remainingSeconds);
  }
  break;

case 'promptOwnLetter':
  break;

case 'promptOpponentLetter':
  setStatusMessage(`Rakip harfi "${data.letter}" geldi. Yerleştirmek için bir hücre seç.`);
  break;

case 'opponentPlacedLetter':
  setStatusMessage(`Rakip oyuncu "${data.letter}" harfini gönderdi. Yerleştirmeni bekliyor.`);
  break;

case 'updateScores':
  setScores({
    myScore: data.playerScore,
    opponentScore: data.opponentScore
  });
  setValidWordCells(Array.isArray(data.validWordCells) ? data.validWordCells : []);
  break;

case 'gameOver':
  if (!(document.visibilityState === 'visible' && soundScreenRef.current === 'game' && visibleGameRef.current === data.gameId) && pendingJoinGameRef.current !== data.gameId) {
    setResultNotices(list=>[...list.filter(n=>n.gameId!==data.gameId),{...data,owner:authenticatedUsernameRef.current}].slice(-10));
    fetchActiveGames(authenticatedUsernameRef.current);
    break;
  }
  if (data.gameId === dismissedResumeGameRef.current && pendingJoinGameRef.current !== data.gameId) break;
  achievementBaselineRef.current = { ...careerStatsRef.current };
  achievementGameRef.current = data.gameId || gameId;
  setNewAchievements([]);
  console.log('[CLIENT][DEBUG] gameOver mesajı alındı. Gelen data:', data);
  const currentUsername = userData?.username || username || sessionStorage.getItem('username') || '';
  const normalizedCurrentUsername = String(currentUsername).toLocaleLowerCase('tr-TR');
  const authoritativeWinner = String(data.winner || '').toLocaleLowerCase('tr-TR');
  const authoritativeLoser = String(data.loser || '').toLocaleLowerCase('tr-TR');
  const didWin = authoritativeWinner
    ? authoritativeWinner === normalizedCurrentUsername
    : Number(data.playerScore) > Number(data.opponentScore);
  const didLose = authoritativeLoser
    ? authoritativeLoser === normalizedCurrentUsername
    : Number(data.playerScore) < Number(data.opponentScore);
  // ResultCelebration owns the cancellable result audio.
  setStatusMessage('');
  if(data.matchMode==='rated')window.dispatchEvent(new CustomEvent('kelimo-badges-updated',{detail:{username:currentUsername}}));
  setGameOverData({
  matchMode:data.matchMode,ratingChange:data.ratingChange,rulesVersion:data.rulesVersion,
  playerScore: data.playerScore ?? 0,
  opponentScore: data.opponentScore ?? 0,
  playerDetails: data.playerDetails || {},
  opponentDetails: data.opponentDetails || {},
  playerBoardHTML: data.playerBoardHTML || '',
  opponentBoardHTML: data.opponentBoardHTML || '',
  opponentUsername: data.opponentUsername || '',
  username: currentUsername,
  gameId: data.gameId || gameId,
  winner: data.winner || null,
  loser: data.loser || null,
  endReason: data.endReason || 'score',
  turnDurationHours: data.turnDurationHours ?? matchClockRef.current,
  clockSpec: data.clockSpec || clockSpecRef.current,
  boardSize: data.boardSize || board.length,
  botDifficulty: data.botDifficulty,
  duel:data.duel||null,
  isForfeit: data.isForfeit === true,
  isDraw: data.isDraw === true
  });
  sessionStorage.setItem('gameOverData', JSON.stringify({
  playerScore: data.playerScore,
  opponentScore: data.opponentScore,
  playerDetails: data.playerDetails,
  opponentDetails: data.opponentDetails,
  playerBoardHTML: data.playerBoardHTML,
  opponentBoardHTML: data.opponentBoardHTML,
  opponentUsername: data.opponentUsername,
  username: currentUsername,
  gameId: data.gameId || gameId,
  winner: data.winner || null,
  loser: data.loser || null,
  endReason: data.endReason || 'score',
  turnDurationHours: data.turnDurationHours ?? matchClockRef.current,
  clockSpec: data.clockSpec || clockSpecRef.current,
  boardSize: data.boardSize || board.length,
  botDifficulty: data.botDifficulty,
  duel:data.duel||null,
  isForfeit: data.isForfeit === true,
  isDraw: data.isDraw === true
}));
  setCurrentScreen('gameOver');  

  
console.log('[DEBUG] fetchActiveGames için username:', currentUsername);
if (currentUsername) {
    console.log('[CLIENT] Sunucunun listeyi güncellemesi için 500ms bekleniyor...');
    setTimeout(() => {
        fetchActiveGames(currentUsername);
        console.log('[CLIENT] fetchActiveGames 500ms gecikmeyle çağrıldı.');
    }, 500); // Yarım saniye (500ms) bekleme
} else {
    console.error('[DEBUG] fetchActiveGames çağrılmadı, username boş!');
}
break;

case 'rematchStart':
  setGameDuel(data.duel||null);
  if(data.duel)sessionStorage.removeItem(`duelReady:${authenticatedUsernameRef.current}:${data.duel.id}`);
  recordConnectionEvent('rematch-start', { gameId: data.gameId, preset: data.clockSpec?.preset || 'legacy', boardSize: data.boardSize, yourTurn: data.yourTurn === true, hadResult: Boolean(gameOverDataRef.current) });
  console.log('[CLIENT] rematchStart alındı.');
  if (data.gameId) {
    setGameId(data.gameId);
    sessionStorage.setItem('gameId', data.gameId);
  }
  resetGameState();
  clockSpecRef.current = data.clockSpec || null;
  setClockSpec(clockSpecRef.current);
  setBotDifficulty(data.botDifficulty ?? null);
  matchClockRef.current = data.turnDurationHours ?? null;
  setMatchClockHours(matchClockRef.current);
  const rematchTurnData = {
    yourTurn: data.yourTurn === true,
    letterToPlace: data.letterToPlace ?? null,
    turnStartTime: data.turnStartTime,
    turnDuration: data.turnDuration,
    joker:data.joker,rulesVersion:data.rulesVersion,matchMode:data.matchMode,
  };
  soundTurnRef.current = rematchTurnData;
  setTurnData(rematchTurnData);
  setGameOverData(null);
  setBoard(Array.from({ length: data.boardSize || 5 }, () => Array(data.boardSize || 5).fill('')));
  console.log('[TRACE] setCurrentScreen("game") çağrıldı — DOSYA içinde tam yer: X satırı');

  setCurrentScreen('game');
  console.log('[CLIENT][DEBUG] Ekran "game" olarak ayarlandı. GameScreen yeniden yüklenecek.');
  setRematchPending(false);
  opponentUsernameRef.current = data.opponentUsername || '';
  setOpponentUsername(data.opponentUsername);
  setOpponentImage(data.opponentImage);
  break;

default:
console.warn('[WS] Bilinmeyen mesaj tipi:', data.type);
}
};

socket.onclose = (event) => {
    if (socketRef.current !== socket) return;
    if (event.code === 4001) {
      expireAccountSession('Hesap güvenliği nedeniyle bu cihazdaki oturum kapatıldı. Yeniden giriş yap.');
      initializeWebSocket();
      return;
    }
    recordConnectionEvent('socket-close', { screen: sessionStorage.getItem('currentScreen') || 'unknown', closeCode:event.code, clean:event.wasClean });
    console.log('❌ WebSocket bağlantısı kapandı.');
    setStatusMessage('Bağlantı kesildi, tekrar bağlanılıyor...');
    socket.authenticated = false;
    setConnectionState('reconnecting');
    if (reconnectTimeoutRef.current) clearTimeout(reconnectTimeoutRef.current);
    const delay = reconnectDelay(reconnectAttemptsRef.current);
    reconnectTimeoutRef.current = setTimeout(() => {
      reconnectTimeoutRef.current = null;
      reconnectAttemptsRef.current += 1;
      initializeWebSocket();
    }, delay);

};

socket.onerror = (err) => {
  if (socketRef.current !== socket) return;
      console.error('🔥 WebSocket hatası:', err);
  setStatusMessage('Bir hata oluştu. Bağlantı sorunu olabilir.');
};
}

useEffect(() => {
  const watch = () => {
    if (document.visibilityState !== 'visible' || navigator.onLine === false || pendingSocialLoginRef.current) return;
    if (pendingJoinGameRef.current && socketRef.current?.authenticated === true && Date.now()-pendingJoinSinceRef.current >= 8000) {
      if (pendingJoinRetriesRef.current++ >= 2) { pendingJoinGameRef.current = null; setMyGamesInitialTab('active'); setCurrentScreen('myGames'); setStatusMessage('Oyun açma isteği yanıtlanmadı. Oyunlarım’dan tekrar deneyebilirsin.'); return; }
      pendingJoinSinceRef.current = Date.now(); renewWebSocket({reason:'join-ack-timeout'}); return;
    }
    const reason = connectionRecoveryReason(socketRef.current, {hasCredentials:Boolean(sessionStorage.getItem('reconnectToken'))});
    if (reason && !reconnectTimeoutRef.current) { recordConnectionEvent('connection-watchdog',{reason}); renewWebSocket({reason}); }
  };
  const timer = setInterval(watch, 2000);
  return () => clearInterval(timer);
}, []);

useEffect(() => {
  const offline = () => {setConnectionState('offline');recordConnectionEvent('network-offline');};
  const online = () => {
    if (pendingSocialLoginRef.current) return;
    const socket = socketRef.current;
    if (socket?.readyState === WebSocket.CONNECTING && Date.now()-(socket.createdAt || 0)<10000) return;
    renewWebSocket({reason:'network-online'});
  };
  window.addEventListener('offline',offline);window.addEventListener('online',online);
  return () => {window.removeEventListener('offline',offline);window.removeEventListener('online',online);};
}, []);

// Mobile browsers can retain an OPEN socket after their network was suspended.
// Renew through the existing authenticated reconnect path after a long absence.
useEffect(() => {
  let menuTimer;
  const backgroundMenu = () => {
    const origin=sessionStorage.getItem('resumeHiddenScreen');
    if(!origin || ['login','register','game','gameOver','dailyGame'].includes(origin))return;
    if(!sessionStorage.getItem('reconnectToken'))return;
    dismissedResumeGameRef.current=sessionStorage.getItem('gameId');
    pendingJoinGameRef.current=null;
    setHomeResumeGeneration(v=>v+1);
    sessionStorage.setItem('currentScreen','start');
    sessionStorage.removeItem('gameId');setGameId(null);setCurrentScreen('start');
  };
  const resume = createResumeRecovery({
    readHiddenAt: () => { const value = sessionStorage.getItem('resumeHiddenAt'); return value == null ? null : Number(value); },
    writeHiddenAt: value => { if (value == null) sessionStorage.removeItem('resumeHiddenAt'); else sessionStorage.setItem('resumeHiddenAt', String(value)); },
    isVisible: () => document.visibilityState !== 'hidden' && window.KelimoNative?.foreground !== false,
    onHide: () => {
      clearTimeout(menuTimer);
      menuTimer=setTimeout(backgroundMenu,30000);
      resumeNotificationRef.current = false;
      sessionStorage.setItem('resumeHiddenScreen', soundScreenRef.current === 'daily' && document.querySelector('.daily-playing') ? 'dailyGame' : soundScreenRef.current);
    },
    onResume: ({awayMs}) => {
      clearTimeout(menuTimer);
      const origin = sessionStorage.getItem('resumeHiddenScreen') || sessionStorage.getItem('currentScreen');
      sessionStorage.removeItem('resumeHiddenScreen');
      if (resumeNotificationRef.current || pendingSocialLoginRef.current) return;
      if (!sessionStorage.getItem('reconnectToken') || ['login','register'].includes(origin)) return;
      const wasGame = ['game','gameOver','dailyGame'].includes(origin);
      if (awayMs >= (wasGame ? 180000 : 30000)) {
        dismissedResumeGameRef.current = sessionStorage.getItem('gameId') || gameOverDataRef.current?.gameId || null;
        pendingJoinGameRef.current = null;
        setHomeResumeGeneration(value=>value+1);
        ++notificationOpenRef.current;
        sessionStorage.setItem('currentScreen', 'start');
        sessionStorage.removeItem('gameId');
        setGameId(null);
        setCurrentScreen('start');
        recordConnectionEvent('background-return-menu', {screen: origin, awayMs});
      } else if (origin === 'game' && !gameOverDataRef.current) {
        // Even a healthy socket must refresh the authoritative game after suspension.
        const id = sessionStorage.getItem('gameId');
        if (id && socketRef.current?.authenticated) {
          pendingJoinGameRef.current = id;
          pendingJoinSinceRef.current = Date.now();
          pendingJoinRetriesRef.current = 0;
          safeSend({type:'joinGame', gameId:id});
        }
      }
    },
    needsConnection: () => Boolean(connectionRecoveryReason(socketRef.current, { hasCredentials: Boolean(sessionStorage.getItem('reconnectToken')) })),
    canRenewAfterAbsence: () => socketRef.current?.readyState !== WebSocket.CONNECTING,
    renew: details => {
      if (pendingSocialLoginRef.current) return;
      renewWebSocket(details);
    },
  });
  resume();
  document.addEventListener('visibilitychange', resume);
  window.addEventListener('focus', resume);
  window.addEventListener('pageshow', resume);
  window.addEventListener('pagehide', resume);
  window.addEventListener('kelimo-native-visibility', resume);
  window.addEventListener('online', resume);
  return () => {
    document.removeEventListener('visibilitychange', resume);
    window.removeEventListener('focus', resume);
    clearTimeout(menuTimer);
    window.removeEventListener('pagehide', resume);
    window.removeEventListener('pageshow', resume);
    window.removeEventListener('kelimo-native-visibility', resume);
    window.removeEventListener('online', resume);
  };
}, []);

const backHandlerRef = useRef(null);
backHandlerRef.current = () => {
  const target = backTarget(soundScreenRef.current, Boolean(sessionStorage.getItem('reconnectToken')));
  if (target.tab) setMyGamesInitialTab(target.tab);
  if (soundScreenRef.current === 'gameOver') {
    // Retain the finished-result ref guard until an authoritative new start clears it.
    sessionStorage.removeItem('gameId'); setGameId(null);
  }
  setCurrentScreen(target.screen);
};
const navigationRef = useRef(null);
useEffect(() => {
  const navigation = installBackNavigation(window, () => soundScreenRef.current, () => backHandlerRef.current());
  navigationRef.current = navigation;
  const nativeBack = () => navigation.back();
  window.addEventListener('kelimo-native-back', nativeBack);
  return () => { window.removeEventListener('kelimo-native-back', nativeBack); navigation.dispose(); };
}, []);
useEffect(() => { navigationRef.current?.screenChanged(); }, [currentScreen]);
useBackLayer(invitePopup.visible, () => setInvitePopup(current => ({ ...current, visible: false })));
useEffect(() => {
  const sendPresence = () => {
    require('./utils/webPush').postView({ foreground: document.visibilityState === 'visible' && window.KelimoNative?.foreground !== false, screen: soundScreenRef.current, gameId: sessionStorage.getItem('gameId') });
    const socket = socketRef.current;
    if (document.visibilityState === 'visible' && navigator.onLine !== false && !pendingSocialLoginRef.current) {
      const reason = connectionRecoveryReason(socket, { hasCredentials: Boolean(sessionStorage.getItem('reconnectToken')) });
      if (reason && !reconnectTimeoutRef.current) {
        recordConnectionEvent('connection-watchdog', { reason });
        renewWebSocket({reason}); return;
      }
    }
    if (socket?.readyState !== WebSocket.OPEN || socket.authenticated !== true || !authenticatedUsernameRef.current) return;
    socket.send(JSON.stringify({ type: 'presence', foreground: document.visibilityState === 'visible' && window.KelimoNative?.foreground !== false,
      screen: soundScreenRef.current, gameId: ['game', 'gameOver'].includes(soundScreenRef.current) ? sessionStorage.getItem('gameId') : null }));

  };
  sendPresence();
  const timer = setInterval(sendPresence, 10000);
  document.addEventListener('visibilitychange', sendPresence);
  window.addEventListener('kelimo-native-visibility', sendPresence);
  return () => { clearInterval(timer); document.removeEventListener('visibilitychange', sendPresence); window.removeEventListener('kelimo-native-visibility', sendPresence); };
}, [authenticatedSessionGeneration, currentScreen, gameId]);

// Refresh conversation after authenticated reconnect, including missed background messages.
useEffect(() => {
  if (!authenticatedSessionGeneration || !username) return;
  const chatId = currentScreen === 'game' ? gameId : currentScreen === 'gameOver' ? gameOverData?.gameId : null;
  if (chatId) safeSend({ type: 'chatGet', gameId: chatId, historyVersion: 2 });
}, [authenticatedSessionGeneration, username, currentScreen, gameId, gameOverData?.gameId]);

//SessionStorage Kaydetme ve Okuma
useEffect(() => {
  sessionStorage.setItem('currentScreen', currentScreen);
}, [currentScreen]);



useEffect(() => {
  if (username) {
    sessionStorage.setItem(`profileImage_${username}`, profileImage);
  }
}, [profileImage, username]);

useEffect(() => {
  sessionStorage.setItem('totalGames', totalGames);
}, [totalGames]);

useEffect(() => {
  sessionStorage.setItem('wins', wins);
}, [wins]);

useEffect(() => {
  sessionStorage.setItem('losses', losses);
}, [losses]);

useEffect(()=>{if(authenticatedSessionGeneration && handoffGameRef.current){const target=handoffGameRef.current;handoffGameRef.current=null;joinGame({gameId:target});}},[authenticatedSessionGeneration]);
useEffect(()=>{if(currentScreen==='newMatch'&&handoffMode)setHandoffMode(null);},[currentScreen,handoffMode]);
//App Açılışında Session’dan Yükleme ve Yönlendirme
useEffect(() => {
  const savedScreen = sessionStorage.getItem('currentScreen');
  const savedUsername = sessionStorage.getItem('username');
  const savedGameOverData = sessionStorage.getItem('gameOverData');

  if (savedGameOverData && savedScreen === 'game') {
    console.log('[SAFELOAD] Oyun bitmişti, gameOver ekranına dönülüyor.');
    setCurrentScreen('gameOver');
    return;
  }

  if (savedScreen === 'game') {
    if (!savedUsername) {
      console.warn('[SAFELOAD] Username yok, login ekranına dönülüyor.');
      setCurrentScreen('login');
    } else {
      console.log('[SAFELOAD] Game ekranı yüklenecek. Username mevcut:', savedUsername);
    }
  } else if (savedScreen === 'start') {
    if (!savedUsername) {
      console.warn('[SAFELOAD] Start için username yok, login ekranına dönülüyor.');
      setCurrentScreen('login');
    } else {
      setCurrentScreen('start');
    }
  }
}, []);

//Kullanıcı Verisi Fetch Etme
useEffect(() => {
  console.log('[FETCH DEBUG] Kullanıcı istatistikleri yükleniyor:', username);
  if (!username || !authenticatedSessionGeneration ||
      authenticatedUsernameRef.current !== username || !sessionStorage.getItem('reconnectToken')) return;
  let cancelled = false, retries = 0, retryTimer;
  const loadAccount = () => fetch(getApiUrl(`/get-user?username=${encodeURIComponent(username)}`), { headers: accountHeaders() })
    .then(res => {
      if (!res.ok) { // Yanıt başarılı değilse
        throw new Error(`HTTP hatası! Status: ${res.status}`);
      }
      return res.json();
    })
    .then(data => {
      if (cancelled) return;
      console.log('[DEBUG] /get-user cevabı:', data);
      const stats = data.stats || {};
      const recentGames = stats.recentGames || [];
  
  setProfileImage(data.profileImage || DEFAULT_AVATAR);
  setRecentGames(recentGames);
  fetchCareerStats(username);
  
if (data.profileImage) {
        console.log('[Avatar] Sunucudan avatar geldi:', data.profileImage);
        setProfileImage(data.profileImage);
        sessionStorage.setItem(`profileImage_${username}`, data.profileImage);
      } else {
        const saved = sessionStorage.getItem(`profileImage_${username}`);
        if (saved) {
          console.log('[Avatar] sessionStorage avatarı kullanılıyor:', saved);
          setProfileImage(saved);
        } else {
          console.log('[Avatar] Hiçbir şey yok, default atanıyor.');
          setProfileImage(DEFAULT_AVATAR);
        }
      }

    })
    .catch(err => {
      if (cancelled) return;
      console.error('İstatistik yükleme hatası:', err);
      if (retries < 3) retryTimer = window.setTimeout(loadAccount, 1000 * (2 ** retries++));
    });
  loadAccount();
  return () => { cancelled = true; window.clearTimeout(retryTimer); };
}, [username, authenticatedSessionGeneration]);



// Oyun sonucunu yalnızca server kaydından yenile; frontend sonuç tahmin etmez.
useEffect(() => {
  if (!gameOverData || !username) return undefined;
  const firstRefresh = window.setTimeout(() => fetchCareerStats(username), 500);
  const reconciliationRefresh = window.setTimeout(() => fetchCareerStats(username), 1500);
  return () => {
    window.clearTimeout(firstRefresh);
    window.clearTimeout(reconciliationRefresh);
  };
}, [gameOverData, username]);

// A result event and the finished-game details button both navigate explicitly.
// Never redirect an active game back to a stale result just because result data exists.
useEffect(() => {
    if (currentScreen === 'gameOver' && !gameOverData) {
      setCurrentScreen(resolveResultScreen(currentScreen, gameOverData, username, gameId));
    }
  }, [gameOverData, currentScreen, username, gameId]);

//Zamanlayıcı Başlatma (turnData değişince)
useEffect(() => {
  if (turnData) {
    const { turnStartTime, turnDuration } = turnData;
    if (turnStartTime && turnDuration) {
      const elapsed = Date.now() - turnStartTime;
      const remaining = turnDuration - elapsed;
      startTimer(Math.max(remaining, 0)); 
    }
  }
}, [turnData, startTimer]);

//Popup Açıldığında Accept Flag Sıfırla

useEffect(() => {
    if (invitePopup.visible) {
      setAcceptSent(false); 
    }
  }, [invitePopup.visible]);


useEffect(() => {
  if (invitePopup.visible) {
    console.log("[DEBUG] Popup açıldı. username:", username, "from:", invitePopup.from);

    // Eğer kendinden gelen bir davetse, otomatik kapat
    if (invitePopup.from === username) {
      console.warn("[CLIENT] 🚫 Kendi gönderdiğim davet. Popup kapatılıyor.");
      setInvitePopup({ visible: false, id: null, from: null, turnDurationHours: null });
    } else {
      setAcceptSent(false); // sadece farklıysa sıfırla
    }
  }
}, [invitePopup.visible, invitePopup.from, username]);

// Unlock Web Audio on a real interaction, including after page reload.
useEffect(() => {
  window.addEventListener('pointerdown', unlockSoundFromGesture, { passive: true });
  window.addEventListener('keydown', unlockSoundFromGesture);
  return () => {
    window.removeEventListener('pointerdown', unlockSoundFromGesture);
    window.removeEventListener('keydown', unlockSoundFromGesture);
  };
}, []);

//WebSocket Cleanup (componentWillUnmount gibi)
useEffect(() => {
    initializeWebSocket();
return () => {
  const previous = socketRef.current;
  socketRef.current = null;
  previous?.close();
  if (reconnectTimeoutRef.current) clearTimeout(reconnectTimeoutRef.current);
};
}, []);
if (currentScreen === 'game') {
  console.log('GameScreen gameOverData:', gameOverData);
}

 console.log('[App] render JSX return öncesi');

return (
  <>
  <DuelNotices key={username} username={username} onOpen={(tab='active')=>{setMyGamesInitialTab(tab);setCurrentScreen('myGames');}}/>
  {currentScreen === 'login' && (
    <LoginScreen
      infoMessage={infoMessage}
      loginError={loginError}
      onLogin={handleLogin}
      onGoogleCredential={handleGoogleCredential}
      onFacebookCredential={handleFacebookCredential}
      onAppleCredential={handleAppleCredential}
      onNavigateToRegister={() => setCurrentScreen('register')} 
    />
  )}
  {currentScreen === 'register' && (
  <RegisterScreen
    onRegister={() => {
      setInfoMessage('✅ Kayıt başarılı! Şimdi giriş yapabilirsin.');
      setCurrentScreen('login');
  }}
  onBackToLogin={() => setCurrentScreen('login')}
  />
)}
  {currentScreen === 'start' && (
    <StartScreen key={`${username}:${homeResumeGeneration}`} onConnectionRequired={requireConnection} initialAction={handoffHomeAction} onInitialActionHandled={()=>setHandoffHomeAction(undefined)} onRecoveryReturnOpened={() => setRecoveryReturnRequest(0)} recoveryReturnRequest={recoveryReturnRequest} allowNotificationPrompt={!invitePopup.visible && !rematchPending}
    onSocialOpen={(section) => { if(!requireConnection())return;setSocialSection(section); safeSend({ type: section === 'notifications' ? 'socialAct' : 'socialGet', action: 'read' }); setCurrentScreen('social'); }}
    socialCount={(social.incoming?.length || 0) + (social.invites?.length || 0) + (social.notices || []).filter(item => !item.read && !item.message?.includes('arkadaşlık isteği gönderdi')).length}
    activeGames={activeGamesState}
    onJoinGame={joinGame}
    onQuickGame={() => { setSocialInvitee(''); setQuickMatch(true); setCurrentScreen('newMatch'); }}
    setCurrentScreen={(screen) => { if(!['start','newMatch','myGames','myGamesFinished'].includes(screen)&&!requireConnection())return;if (screen === 'newMatch') { setQuickMatch(false); setSocialInvitee(''); } if (screen === 'myGamesFinished') { setMyGamesInitialTab('finished'); setCurrentScreen('myGames'); return; } if (screen === 'myGames') setMyGamesInitialTab('active'); setCurrentScreen(screen); }}
  onLogout={() => {
    setSocialAlert(null);seenSocialNoticesRef.current=new Set();knownFriendRequestsRef.current=null;setSocialActionResult(null);setSocialActionError(null);
    setStatusMessage('');
    void disconnectNativePush(username, sessionStorage.getItem('reconnectToken'))
      .catch(error => console.warn('[PUSH] Cihaz kaydı kaldırılamadı:', error));
    void disconnectWebPush(username, sessionStorage.getItem('reconnectToken')).catch(() => {});
    void fetch(getApiUrl(`/logout-session?username=${encodeURIComponent(username)}`), { method: 'POST', headers: accountHeaders() }).catch(() => {});
    forgetSession(sessionStorage, localStorage);
    safeSend({ type: 'logout' });
    setGameOverData(null);
  setInvitePopup({ visible: false, id: null, from: null, turnDurationHours: null });
  void disconnectWebPush(sessionStorage.getItem('username'), sessionStorage.getItem('reconnectToken')).catch(() => {});
  forgetSession(sessionStorage, localStorage);
  authenticatedUsernameRef.current = '';
  pendingJoinGameRef.current = null;
  setUserData(null);
  setChats({});
  setActiveGames([]);
  sessionStorage.removeItem('gameOverData');

  setUsername('');
  sessionStorage.removeItem('username');
  sessionStorage.removeItem('reconnectToken');
  sessionStorage.removeItem('gameId');

  sessionStorage.removeItem('currentScreen');
  setCurrentScreen('login');
  localStorage.removeItem('kelimoOfflineActive');
  window.dispatchEvent(new Event('kelimo-session-ended'));
    }}
  username={userData?.username || username}
  dictionaryAdminEnabled={userData?.dictionaryAdminEnabled === true}
  profileImage={profileImage}
  setProfileImage={setProfileImage}
  onlineCount={onlineCount}
  totalGames={totalGames}
  winRate={careerWinRate}
  averageScore={careerAverageScore}
  wins={wins}
  losses={losses}
  recentGames={recentGames}
  onAvatarChange={handleAvatarChange}
  
  />
  )}
  {resultNotices.filter(n=>n.owner===username).slice(-1).map(n=><div key={n.gameId} className="result-notice-r20" role="status"><button type="button" onClick={()=>{setResultNotices(list=>list.filter(x=>x.gameId!==n.gameId));void openNotificationGame({gameId:n.gameId,kind:'result',tab:'finished',celebrate:true},username);}}>{n.opponentUsername||'Rakip'} ile olan oyunu {n.isDraw?'berabere bitirdiniz':String(n.winner||'').toLowerCase()===String(username).toLowerCase()?'kazandınız':'kaybettiniz'}. <b>Sonucu gör</b></button><button type="button" aria-label="Sonuç bildirimini kapat" onClick={()=>setResultNotices(list=>list.filter(x=>x.gameId!==n.gameId))}>×</button></div>)}
  {socialAlert && socialAlert.owner===username && username && <SocialAlert alert={socialAlert} onShown={rememberSocialAlert}
    onOpen={()=>{rememberSocialAlert(socialAlert);setSocialAlert(null);safeSend({type:'socialAct',action:'read'});safeSend({type:'socialGet'});setSocialSection('friends');setCurrentScreen('social');}}
    onDismiss={()=>{rememberSocialAlert(socialAlert);setSocialAlert(null);safeSend({type:'socialAct',action:'read'});}}/>}
  {currentScreen === 'social' && (
    <SocialScreen username={username} section={socialSection} state={social} searchResults={socialSearchResults} actionResult={socialActionResult} actionError={socialActionError}
      send={data=>{if(data.type==='socialSearch'){socialSearchQueryRef.current=data.query;setSocialSearchResults([]);}return safeSend(data);}} onBack={goBack}
      onInvite={(name) => { if (name) { setQuickMatch(false); setSocialInvitee(name); } else setMyGamesInitialTab('invites'); setCurrentScreen(name ? 'newMatch' : 'myGames'); }} />
  )}
  {['market','achievements','ranking'].includes(currentScreen)&&<SectionDock active={currentScreen} onNavigate={screen=>{setCurrentScreen(screen);window.scrollTo({top:0});}}/>}
  {currentScreen === 'ranking'&&<DailyLeaderboard username={username} onBack={()=>setCurrentScreen('start')} onDaily={()=>setCurrentScreen('daily')}/>}
  {currentScreen === 'market'&&<MarketScreen key={username} username={username} profileImage={profileImage} onBack={()=>setCurrentScreen('start')}/>}
  {currentScreen === 'daily'&&<DailyChallengeScreen onTransportState={setDailyTransportIssue} key={username} username={username} connectionReady={connectionState==='ready'} onBack={()=>setCurrentScreen('start')}/>}
  {currentScreen === 'achievements' && <AchievementsScreen username={username} onBack={goBack} />}
  {currentScreen === 'newMatch' && <NewMatchScreen onConnectionRequired={requireConnection} initialMode={handoffMode} offlineReady={offlineReady} onOffline={onOffline} key={username} username={username} connectionReady={connectionState === 'ready' && socketRef.current?.authenticated === true}
    onBack={goBack} initialInvitee={socialInvitee} quickSetup={quickMatch}
    friends={social.friends || []} playerAvatars={social.playerAvatars || {}} playerDisplayNames={social.playerDisplayNames || {}} presence={social.presence || {}} searchResults={socialSearchResults}
    onSearch={query => {socialSearchQueryRef.current=query;setSocialSearchResults([]);safeSend({ type: 'socialSearch', query }); }}
    onRandomGame={(clockPreset, boardSize, matchKind='single', matchMode='rated') => {
      if (socketRef.current?.readyState !== WebSocket.OPEN || socketRef.current.authenticated !== true) return false;
      socketRef.current.send(JSON.stringify({ type: 'startGame', clockPreset, boardSize, matchKind,matchMode })); return true;
    }}
    onCancelRandomGame={() => safeSend({ type: 'cancelMatchmaking' })}
    social={social} friendError={friendActionError} onFriendAction={sendFriendAction}
    onInvite={(to, clockPreset, boardSize,matchKind='single',options={}) => {
      if (socketRef.current?.readyState !== WebSocket.OPEN || socketRef.current.authenticated !== true) return false;
      socketRef.current.send(JSON.stringify({type:'invite',to,clockPreset,boardSize,matchKind,matchMode:options.matchMode||'casual',requestId:options.requestId,targetUsername:options.targetUsername}));return true;
    }}
    onComputerMatch={(clockPreset, botDifficulty, boardSize) => {
      return onOffline({clockPreset,botDifficulty,boardSize,username});
    }} />}

{currentScreen === 'myGames' && (
  <MyGamesScreen
    onOpenLocalResult={game=>onOffline({resultGameId:game.gameId,username:authenticatedUsernameRef.current})}
    initialTab={myGamesInitialTab}
    username={username}
    setCurrentScreen={setCurrentScreen}
    pushInviteId={pushInviteId}
    setGameOverData={setGameOverData}
    onJoinGame={joinGame}
    onAcceptInvite={(invite) => { if(soundScreenRef.current==='game')acceptedWhilePlayingRef.current.add(invite.id); if(!safeSend({ type: 'acceptInvite', inviteId: invite.id }))return false; if(invite.matchKind==='duel')setMyGamesInitialTab('duels'); setSocial(current => ({ ...current, invites: current.invites.filter(item => item.id !== invite.id) })); }}
    onRejectInvite={(invite) => { if(!safeSend({ type: 'rejectInvite', inviteId: invite.id }))return false; setSocial(current => ({ ...current, invites: current.invites.filter(item => item.id !== invite.id) })); }}
  />
)}



  <ConnectionStatus active={Boolean(username && (connectionState !== 'ready'||currentScreen==='daily'&&dailyTransportIssue))} phase={navigator.onLine===false?'offline':currentScreen==='daily'&&dailyTransportIssue?'reconnecting':connectionState} required={['game','daily','market','social','achievements'].includes(currentScreen)} request={connectionRequest} playing={currentScreen==='game'||currentScreen==='daily'} onRetry={()=>{renewWebSocket();window.dispatchEvent(new Event('kelimo-daily-retry'));}}/>

  {statusMessage && !isConnectionNotice(statusMessage) && currentScreen !== 'game'  && currentScreen !== 'gameOver' && (
    <div className="kelimo-status-toast">
      <span>{statusMessage}</span>
      <button type="button" aria-label="Bildirimi kapat" className="ml-3 font-bold" onClick={() => setStatusMessage('')}>×</button>
    </div>
  )}

  {invitePopup.visible && (
    <InvitePopup
      from={invitePopup.from}
      displayName={invitePopup.fromDisplayName}
      clockSpec={invitePopup.clockSpec}
      turnDurationHours={invitePopup.turnDurationHours}
      boardSize={invitePopup.boardSize || 5}
      matchKind={invitePopup.matchKind||'single'} matchMode={invitePopup.matchMode||'casual'}
      onAccept={() => {
      if (!acceptSent && invitePopup.from !== username) {
      if(soundScreenRef.current==='game')acceptedWhilePlayingRef.current.add(invitePopup.id);
      const msg = { type: 'acceptInvite', inviteId: invitePopup.id };
  console.log('[CLIENT] acceptInvite gönderiliyor:', msg);
  if(!safeSend(msg))return;
  setAcceptSent(true);
    }
    setInvitePopup({ visible: false, id: null, from: null, turnDurationHours: null });
  }}
      onReject={() => {
      const msg = { type: 'rejectInvite', inviteId: invitePopup.id };
  console.log('[CLIENT] rejectInvite gönderiliyor:', msg);
  if(!safeSend(msg))return;
  setInvitePopup({ visible: false, id: null, from: null, turnDurationHours: null });
}}
      onLater={() => setInvitePopup({ visible: false, id: null, from: null, turnDurationHours: null })}
    />
  )}
  
  {currentScreen === 'game' && (
    <GameScreen
      key={gameId || 'default'}
      gameIdOverride={gameId}
      socket={socketRef.current}
      connectionReady={connectionState === 'ready'} onRecover={renewWebSocket}
      turnData={turnData}
      clockSpec={clockSpec}
      turnDurationHours={matchClockHours}
      scores={scores}
      board={board}
      setBoard={setBoard}
      ownLetterDraft={ownLetterDraft}
      botDifficulty={botDifficulty}
      duel={gameDuel}
      validWordCells={validWordCells}
      gameOverData={gameOverData}
      username={username}
      profileImage={profileImage}
      opponentImage={opponentImage}                       
      opponentUsername={opponentUsername}
      social={social} onFriendAction={sendFriendAction} friendActionError={friendActionError}
      setCurrentScreen={setCurrentScreen}
      onBack={() => { setMyGamesInitialTab('active'); setCurrentScreen('myGames'); }}
      isReconnect={isReconnect}
      chat={chats[gameId] || { messages: [], unread: 0 }}
      chatGameId={gameId}
      onChatGet={() => safeSend({ type: 'chatGet', gameId, historyVersion: 2 })}
      onChatOlder={before => safeSend({ type: 'chatGet', gameId, before, historyVersion: 2 })}
      onChatSend={text => sendChatMessage(gameId, text)}
      onChatReport={(messageId, reason) => safeSend({ type: 'chatReport', gameId, messageId, reason })}
      onChatRead={() => safeSend({ type: 'chatRead', gameId })}
    />
  )}
  {currentScreen === 'gameOver' && gameOverData && (
  <GameOverScreen
    data={gameOverData}
    onBack={goBack}
    newAchievements={newAchievements}
    chat={chats[gameOverData.gameId] || { messages: [], unread: 0 }}
    onChatGet={() => safeSend({ type: 'chatGet', gameId: gameOverData.gameId, historyVersion: 2 })}
    onChatOlder={before => safeSend({ type: 'chatGet', gameId: gameOverData.gameId, before, historyVersion: 2 })}
    onChatSend={text => sendChatMessage(gameOverData.gameId, text)}
    onChatReport={(messageId, reason) => safeSend({ type: 'chatReport', gameId: gameOverData.gameId, messageId, reason })}
    onChatRead={() => safeSend({ type: 'chatRead', gameId: gameOverData.gameId })}
    username={username}                 
    onExit={() => {
      console.log('[CLIENT] exitGame mesajı gönderiliyor...');
      if (socketRef.current && socketRef.current.readyState === WebSocket.OPEN) {
    const msg = { type: 'exitGame' };
  console.log('[CLIENT] exitGame mesajı gönderiliyor:', msg);
  socketRef.current.send(JSON.stringify(msg));
}
      resetGameState();
      setGameOverData(null);
      setNewAchievements([]);
      achievementGameRef.current = null;
      sessionStorage.removeItem('currentScreen');
      sessionStorage.removeItem('gameOverData');
      sessionStorage.removeItem('gameId');
      setGameId(null);
      setOpponentUsername('');
      opponentUsernameRef.current = '';
      setOpponentImage('');
      setCurrentScreen('start');       
    }}
    social={social} onFriendAction={sendFriendAction} friendActionError={friendActionError}
    onRematch={(target, options) => {
      if (String(target).toLocaleLowerCase('tr-TR') === 'bilgisayar') {
        if(options.preset==='legacy'){try{const message=rematchMessage(target,options,gameOverData);if(socketRef.current?.readyState!==WebSocket.OPEN||!socketRef.current.authenticated)return false;safeSend(message);return true;}catch(error){setStatusMessage(error.message);return false;}}
        if (!offlineReady || ![1,3,5].includes(options.botDifficulty ?? gameOverData.botDifficulty)) return false;
        return onOffline({clockPreset:options.preset,boardSize:options.boardSize,botDifficulty:options.botDifficulty ?? gameOverData.botDifficulty,username});
      }
      if (socketRef.current?.readyState !== WebSocket.OPEN) return false;
      try {
        const message = rematchMessage(target, options, gameOverData);
        socketRef.current.send(JSON.stringify(message));
        if (message.type === 'invite') setRematchPending(true);
        return true;
      } catch (error) { setStatusMessage(error.message); return false; }
    }}
    rematchPending={rematchPending}
    setRematchPending={setRematchPending}  
  />
)}
</>
);
}

export default function App() {
  const [localOptions,setLocalOptions]=useState(null);
  const [onlineOptions,setOnlineOptions]=useState(null);
  const transition=useRef({generation:0,controller:null});
  const [sessionGeneration,setSessionGeneration]=useState(0);
  const identity=()=>({username:sessionStorage.getItem('username')||'',token:sessionStorage.getItem('reconnectToken')||''});
  const hasIdentity=()=>{const value=identity();return Boolean(value.username&&value.token);};
  const authenticationScreen=()=>['login','register'].includes(sessionStorage.getItem('currentScreen'));
  const [offlineReady,setOfflineReady]=useState(false);
  useEffect(()=>{let active=true;const ready=()=>prepareOfflineDictionary().then(async dictionary=>{const available=Boolean(dictionary?.words?.length)&&await offlineShellReady();if(active)setOfflineReady(available);}).catch(()=>{});ready();window.addEventListener('online',ready);navigator.serviceWorker?.addEventListener('controllerchange',ready);return()=>{active=false;window.removeEventListener('online',ready);navigator.serviceWorker?.removeEventListener('controllerchange',ready);};},[]);
  const [offline,setOffline] = useState(() => {
    // A local-mode marker is navigation state, never an authenticated account.
    if(!hasIdentity()||authenticationScreen()){
      localStorage.removeItem('kelimoOfflineActive');
      if(!hasIdentity()&&sessionStorage.getItem('currentScreen')!=='register')sessionStorage.setItem('currentScreen','login');
      return false;
    }
    return !new URLSearchParams(window.location.search).has('kelimoPush')&&sessionStorage.getItem('currentScreen')!=='daily'&&(navigator.onLine===false||localStorage.getItem('kelimoOfflineActive')==='1');
  });
  useEffect(()=>{
    const changed=()=>{
      ++transition.current.generation;transition.current.controller?.abort();
      setSessionGeneration(value=>value+1);
      if(!hasIdentity()){
        localStorage.removeItem('kelimoOfflineActive');setLocalOptions(null);setOnlineOptions({screen:'login'});setOffline(false);
      }
    };
    window.addEventListener('kelimo-session-ready',changed);window.addEventListener('kelimo-session-ended',changed);
    return()=>{++transition.current.generation;transition.current.controller?.abort();window.removeEventListener('kelimo-session-ready',changed);window.removeEventListener('kelimo-session-ended',changed);};
  },[]);
  useEffect(() => {
    if (!offline || !navigator.serviceWorker) return;
    const open = event => {
      const data = event.data;
      if (data?.type !== 'push-open' || !['result','turn','time','invite','friend'].includes(data.kind) || typeof data.gameId !== 'string' || data.gameId.length > 150 || !/^[a-f0-9]{64}$/.test(data.binding || '')) return;
      const url = new URL(window.location.href); url.searchParams.set('kelimoPush',data.kind); url.searchParams.set('target',data.gameId); url.searchParams.set('binding',data.binding);
      window.history.replaceState(window.history.state,'',url); localStorage.removeItem('kelimoOfflineActive'); setOffline(false);
    };
    navigator.serviceWorker.addEventListener('message',open); return () => navigator.serviceWorker.removeEventListener('message',open);
  },[offline]);
  useEffect(()=>{
    const disconnected=()=>{
      // Do not infer "offline" from a failed HTTP probe or leave an auth screen.
      if(navigator.onLine!==false||offline||!offlineReady||!hasIdentity()||authenticationScreen()||new URLSearchParams(window.location.search).has('kelimoPush')||['game','daily'].includes(sessionStorage.getItem('currentScreen')))return;
      recordConnectionEvent('local-mode-enter',{clientVersion:'v242-r5',reason:'browser-offline'});
      setLocalOptions({resumeLast:true,username:identity().username});localStorage.setItem('kelimoOfflineActive','1');setOffline(true);
    };
    window.addEventListener('offline',disconnected);disconnected();
    return()=>window.removeEventListener('offline',disconnected);
  },[offlineReady,offline,sessionGeneration]);
  const enter = options => {
    if(!hasIdentity()||authenticationScreen())return false;
    const owner=identity().username;
    if(options?.username&&options.username!==owner)return false;
    const selected=options?.clockPreset||options?.resumeGameId||options?.resultGameId?{...options,username:owner}:{resumeLast:true,username:owner};
    recordConnectionEvent('local-mode-enter',{clientVersion:'v242-r5',reason:'user-choice'});
    setLocalOptions(selected);localStorage.setItem('kelimoOfflineActive','1');setOffline(true);return true;
  };
  const leave = async (options={screen:'start'},guard=null) => {
    if(options.screen==='login'){
      recordConnectionEvent('local-mode-logout',{clientVersion:'v242-r5'});
      const account=identity();++transition.current.generation;transition.current.controller?.abort();
      if(account.username&&account.token&&navigator.onLine!==false){
        void fetch(getApiUrl(`/logout-session?username=${encodeURIComponent(account.username)}`),{method:'POST',headers:{Authorization:`Bearer ${account.token}`}}).catch(()=>{});
        void disconnectWebPush(account.username,account.token).catch(()=>{});void disconnectNativePush(account.username,account.token).catch(()=>{});
      }
      forgetSession(sessionStorage,localStorage);
      for(const key of ['username','reconnectToken','gameId','gameOverData','totalGames','wins','losses'])sessionStorage.removeItem(key);
      sessionStorage.setItem('currentScreen','login');localStorage.removeItem('kelimoOfflineActive');
      setLocalOptions(null);setOnlineOptions({screen:'login'});setOffline(false);window.dispatchEvent(new Event('kelimo-session-ended'));return true;
    }
    if(!hasIdentity())return leave({screen:'login'});
    if(navigator.onLine===false)return {ok:false,reason:'offline'};
    const owner=identity(),generation=++transition.current.generation;
    transition.current.controller?.abort();const controller=new AbortController();transition.current.controller=controller;
    const timer=setTimeout(()=>controller.abort(),8000);
    const current=()=>generation===transition.current.generation&&owner.username===identity().username&&owner.token===identity().token&&(!guard?.isCurrent||guard.isCurrent());
    try{
      const response=await fetch(getApiUrl('/client-version'),{signal:controller.signal,cache:'no-store'});
      if(!current())return {ok:false,reason:'cancelled'};
      if(navigator.onLine===false)return {ok:false,reason:'offline'};
      if(!response.ok)return {ok:false,reason:'server'};
      sessionStorage.setItem('currentScreen',options.screen||'start');
      if(options.detail){sessionStorage.setItem('gameOverData',JSON.stringify(options.detail));sessionStorage.removeItem('gameId');}
      if(options.gameId){sessionStorage.setItem('gameId',options.gameId);sessionStorage.removeItem('gameOverData');}
      recordConnectionEvent('local-online-return',{clientVersion:'v242-r5'});
      setOnlineOptions(options);localStorage.removeItem('kelimoOfflineActive');setOffline(false);return true;
    }catch(_){return {ok:false,reason:current()?'server':'cancelled'};}
    finally{clearTimeout(timer);if(transition.current.controller===controller)transition.current.controller=null;}
  };
  return offline ? <OfflineGame onExit={leave} initialOptions={localOptions}/> : <OnlineApp initialOnlineOptions={onlineOptions} onOffline={enter} offlineReady={offlineReady}/>;
}
